/* global SETTINGS:false */
__webpack_public_path__ = `${SETTINGS.public_path}`; // eslint-disable-line no-undef, camelcase
import "../../scss/layout.scss";
import "@mitodl/react-dropzone-uploader/dist/styles.css";
